// 好友关系表
import { DB, ExecuteResult } from "./index";
import time from "../time";

const upsert_sql =
  "insert into t_friend_black(" +
  "uid, black, lutime, lctime" +
  ") values(" +
  "?, ?, ?, ?" +
  ") ON CONFLICT(uid) DO UPDATE SET " +
  "black=?, lutime=?;";

export async function friend_black_upsert(
  db: DB,
  friend: FriendBlack
): Promise<ExecuteResult> {
  const timeUNIX = time.toUnixMillSecond(time.now());
  const d = FriendBlackToEntity(fixFriendBlack(friend));
  d.lctime = timeUNIX;
  d.lutime = timeUNIX;
  const params = [];
  // INSERT
  params.push(...[d.uid, d.black, d.lutime, d.lctime]);
  // UPDATE
  params.push(...[d.black, d.lutime]);
  return await db.Execute(upsert_sql, params);
}

export async function queryBlackLocal(db: DB): Promise<{ error: any; blacks?: Entity[] }> {
  const sql = `select * from t_friend_black`;
  const r = await db.Query(sql, []);
  if (r.error) {
    return { error: r.error };
  }
  if (!(r.data && r.data.length > 0)) {
    return { error: null };
  }
  const d = r.data as Entity[];
  return { error: null, blacks: d };
}

export async function friend_black_del(
  db: DB,
  friendUid: number
): Promise<ExecuteResult> {
  return await db.Execute(`delete from t_friend_black where uid= ? `, [friendUid]);
}

function FriendBlackToEntity(a: FriendBlack): Entity {
  const b: Entity = {
    uid: a.uid,
    black: a.black,
    lutime: a.lutime,
    lctime: a.lctime
  };
  return b;
}

function fixFriendBlack(a: FriendBlack): FriendBlack {
  return Object.assign({}, defaultFriend, a);
}

export type FriendBlack = {
  uid: number; // 朋友的uid
  black: string;
  lutime: number; // 本地 记录最后的修改时间
  lctime: number; // 本地 记录的创建时间
};

export const defaultFriend: FriendBlack = {
  uid: 0, // 朋友的uid
  black: "", // 朋友的uid
  lutime: 0, // 本地 记录最后的修改时间
  lctime: 0 // 本地 记录的创建时间
};

type Entity = {
  uid: number; // 朋友的uid
  black: string; // 1是黑名单
  lutime: number; // 本地 记录最后的修改时间
  lctime: number; // 本地 记录的创建时间
};
